<template>
    <div class="">
        <router-view />
    </div>
</template>

<script>
export default {
    name: 'App'
}
</script>

<style>
* {
    margin: 0;
    padding: 0;
    font-family: PingFang SC;
  /* font-weight: 600; */
  font-style: Semibold;
    /* background-color: #ffffff; */
}
.flex {
    display: flex;
    align-items: center;
}
</style>
